import { render } from "./MovieView.vue?vue&type=template&id=7e46d2f9"
import script from "./MovieView.vue?vue&type=script&lang=js"
export * from "./MovieView.vue?vue&type=script&lang=js"

import "./MovieView.vue?vue&type=style&index=0&id=7e46d2f9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__